import React from 'react';

import { Button, ButtonProps } from '@mui/material';

export type CustomButtonVariant = 'primary' | 'danger' | 'secondary' | 'success';

type CustomButtonProps = {
  label: string;
  buttonVariant?: CustomButtonVariant;
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
} & Omit<ButtonProps, 'variant' | 'color' | 'onClick'>;

const variantStyles: Record<
  CustomButtonVariant,
  { variant: ButtonProps['variant']; color: ButtonProps['color']; sx: object }
> = {
  primary: {
    variant: 'contained',
    color: 'primary',
    sx: {
      textTransform: 'none',
      fontWeight: 600,
      px: 3,
      borderRadius: 2,
    },
  },
  danger: {
    variant: 'contained',
    color: 'error',
    sx: {
      textTransform: 'none',
      fontWeight: 600,
      px: 3,
      borderRadius: 2,
    },
  },
  secondary: {
    variant: 'outlined',
    color: 'inherit',
    sx: {
      textTransform: 'none',
      fontWeight: 600,
      px: 3,
      borderRadius: 2,
    },
  },
  success: {
    variant: 'contained',
    color: 'success',
    sx: {
      textTransform: 'none',
      fontWeight: 600,
      px: 3,
      borderRadius: 2,
    },
  },
};

const CustomButton: React.FC<CustomButtonProps> = ({
  label,
  buttonVariant = 'primary',
  icon,
  onClick,
  disabled = false,
  fullWidth = false,
  ...rest
}) => {
  const style = variantStyles[buttonVariant];

  return (
    <Button
      variant={style.variant}
      color={style.color}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      startIcon={icon}
      sx={style.sx}
      {...rest}
    >
      {label}
    </Button>
  );
};

export default CustomButton;
